const store = new Map();

export const simpleDataStoreMiddleware = next => ({ directive, meta }) => {
  if (directive.returnData) {
    return next({
      directive: {
        ...directive,
        args: { [directive.returnData]: store.get(directive.returnData), ...(directive.args || {}) },
      },
    });
  }

  if (directive.useData) {
    const { useData, ...rest } = directive;
    return next({ directive: { ...rest, call: () => useData(store) }, meta });
  }

  const result = next({ directive, meta });

  if (directive.saveDataAs) {
    if (result.then) {
      result.then((response) => {
        store.set(directive.saveDataAs, response);
      });
    } else {
      store.set(directive.saveDataAs, result);
    }
  }

  return result;
};
